import styled from 'styled-components'
import {  Form  } from 'react-bootstrap'



export const ContactItem = styled.div`
padding: 20px;
background-color: white;
text-align: center;
box-shadow: 0 0 30px rgb(214 215 216 / 30%);
margin-bottom: 20px;
h6{
    margin-top: 20px;
    font-size: 20px;
    font-weight: 700;
    color: #676464;
}
p{
    color: #767676;
    font-size: 15px;
}
`;

export const ContactIcon = styled.div`
margin-bottom: 27px;
width: 50px;
height: 50px;
line-height: 50px;
border: 1px solid var(--primaryColor);
border-radius: 50%;
margin: 0 AUTO;
i{
    font-size: 20px;
    color: var(--primaryColor);
}
`;

export const ContactForm=styled(Form)`
padding: 20px;
background-color: white;
box-shadow: 0 0 30px rgb(214 215 216 / 30%);
input ,textArea{
    margin: 14px 0px;
}
textArea{
    height: 100px;
}
`;

export const ContactImage=styled.img`
width: 100%;
height: 400px;

`;
